module.exports = __webpack_public_path__ + "static/media/code9.9a35c17e.png";